const matchesPath = (url, normPath) => {
  const normUrl = (url || "").replace(/^\/+/, "");
  if (!normUrl) return false;
  return normPath === normUrl || normPath.startsWith(normUrl + "/");
};

export const isItemActive = (item, currentPath) => {
  const normPath = currentPath.replace(/^\/+/, "");
  if (matchesPath(item.url || item.to, normPath)) return true;
  return (item.children || []).some(
    (child) =>
      matchesPath(child.url || child.to, normPath) ||
      (child.children || []).some((grandchild) => matchesPath(grandchild.url || grandchild.to, normPath))
  );
};
